import HTMLTemplate from './template.html'
import './styles.scss'
import 'vue-css-donut-chart/dist/vcdonut.css'

import SecurityCMS from '../../../../services/api/SecurityCMS/ApiService'
import ClientPortalAPIService from '../../../../services/api/ClientPortal/ApiService'
import tippy, { followCursor } from 'tippy.js';
import { riskDefinitions } from '../../../../RiskDefinitions'
import MixPanelService from '../../../../services/MixPanelService'
import { cloneDeep } from 'lodash'
import InternationalSOSAlerts from '../../../../modules/InternationalSOSAlerts'
import AvsecAlerts from '../../../../modules/avsecAlerts'
import moment from 'moment'
import 'moment-timezone'
import Donut from 'vue-css-donut-chart'
import isEmail from 'validator/lib/isEmail'
import User from '../../../../modules/user'
import CountryRisk from '../../../../modules/countryRisk'
import { filterInternationalSOSAlerts } from '../../../../services/EventsService'
import RiskIntelligenceAPIService from '../../../../services/api/RiskIntelligence/ApiService'
import MaritimeAlerts from '../../../../modules/maritimeAlerts'
import * as turf from '@turf/turf'
import mapboxgl from 'mapbox-gl'
import { config } from '../../../../Config'
import { addMapImages } from '../../../../services/map'
import Ports from '../../../../modules/ports'
import Cities from '../../../../modules/cities'
import Sentry from '../../../../modules/SantryIO'
import poweredbyRIImage from './../../../../resources/images/luxury-yachting/poweredbyRI.png'

export const DetailsPanel = (() => {
    // Commented items will need to be connected to the proxy API, they don't come through Security CMS, but
    // we will connect them from Country guides API
    const cityDetails = {
        overview: {
            // portOfEntry: '',
            securityOverview: '',
            orientation: '',
            cityCalendar: ''
        },
        security: {
            seekingHelp: '',
            crime: '',
            socialUnrest: '',
            terrorism: '',
            troubleSpots: ''
        },
        transport: {
            toCityCentre: '',
            taxis: '',
            publicTransport: '',
            walking: '',
            carHire: ''
        },
        keyinfo: {
            // curfews: '',
            diplomaticRepresentation: '',
            emergencyMedicalCare: '',
            emergencyNumbers: '',
            lodging: ''
        },
        alerts: []
    }

    const countryDetails = {
        overview: {
            assessment: '',
            conclusion: '',
            emergencyNumbers: ''
        },
        travel: {
            riskSummary: '',
            securityAlerts: '',
            standingTravelAdvice: '',
            businessWomen: '',
            entryExitRequirements: ''
        },
        background: {
            countryRuleOfLaw: '',
            countryConflict: '',
            politicalSituation: '',
            countryCorruption: '',
            borderConcerns: '',
            socialUnrest: '',
            naturalDisasters: '',
            recentHistory: ''
        },
        alerts: [],
        medical: {
            waterrisk: '',
            foodrisk: '',
            vaccination: [],
            routinevaccination: [],
            medicalalertteaser: [],
            emgresponse: '',
            outpatientcare: '',
            healthcarepayment: '',
            dentalcare: '',
            availmeds: '',
            bloodsupplies: '',
            diseases: [],
            GeneralDiseaseAndPreventionContent: []
        }
    }

    const countryCovidRestrictions = {
        impactRatings: {
            domesticOperations: 0,
            travel: 0
        },
        generalRating: 0,
        restrictionList: [],
        domesticRatingDisplay: '',
        travelRatingDisplay: ''
    }

    const portDetails = {
        threatAssessment: {
            summary: '',
            threats: [],
        },
        vulnerabilities: {
            summary: '',
            mitigationMethods: []
        },
        security: {
            summary: '',
            recommendations: []
        },
        alerts: []
    }

    const guessedTimeZone = moment.tz(moment.tz.guess()).format('z')

    var vueComponent = {
        data() {
            return {
                portCurrentTab: 'Security', // Vulnerability, Threat, Alerts, Contacts
                cityCurrentTab: 'Overview', // Security, Transport, Key Info
                countryCurrentTab: 'Overview', // Travel, Background, Weaponry, Aviation
                cityDetails: cloneDeep(cityDetails),
                countryDetails: cloneDeep(countryDetails),
                isLoading: false,
                covidRestrictions: {
                    countryRestrictions: [],
                    covidImpactDefinitions: {
                        travel: {},
                        domesticOperations: {}
                    }
                },
                currentCountryCovidRestrictions: countryCovidRestrictions,
                isDetailsPanelOpen: false,
                currentActiveModule: 'city', // city, country
                missingInformationBanner: `
                    <div class="banner__content">
                        <h4 class="banner__title f-subheading">Contact MedAire for information on this location</h4>
                        <p class="banner__text">Our team can provide a full security and medical report for this location on request</p>
                    </div>
                    <div class="banner__action">
                        <button" class="button button--1 button--sm button--spaced request-info-button" type="button">
                            <span class="button__text">Request Info</span>
                        </button>
                    </div>
                `,
                riskDefinitions: riskDefinitions,
                isDownloadingReport: false,
                expandAssociatedAlerts: false,

                userEmail: '',
                userName: '',
                userCompany: '',
                userPermissions: [],

                requestInfoAirportCode: '',
                requestInfoAirport: '',
                requestInfoCity: '',
                requestInfoCountry: '',

                requestInfoTitle: '',
                requestInfoSubtitle: '',
                requestInfoUserEmail: '',
                requestInfoUserName: '',
                requestInfoUserCompany: '',
                requestInfoUserAdditionalNote: '',
                requestInfoSubmitted: false,
                isSubmittingRequestInfo: false,
                requestInfoSuccessfullySubmitted: false,
                requestInfoAPIError: '',
                requestInfoType: '',

                // New for City Details Panel
                cityName: '',
                countryName: '',
                cityRating: 0,
                countryRating: 0,
                countryMedicalRating: 0,
                countryISO_3166_1_ALPHA_2: '',
                countryISO_3166_1_ALPHA_3: '',

                countryDetailsOnly: false,
                showPortDetails: false,
                medicalCountryRiskDisplay: false,
                loadingSkeleton: `
                    <div class="skeleton-container">
                        <div class="skeleton-panel">
                            <div class="skeleton skeleton--risks">
                                <div class="skeleton__bone">
                                    <span class="skeleton__bone-text f-label-3">Loading</span>
                                </div>
                            </div>
                            <!-- Need to layout and set timer triggers -->
                            <div class="skeleton-l-details-panel">
                                <div class="skeleton-l-details-panel__left">
                                    <div class="skeleton skeleton--content">
                                        <div class="skeleton__bone skeleton__bone--sm"></div>
                                        <div class="skeleton__bone skeleton__bone--sm"></div>
                                        <div class="skeleton__bone skeleton__bone--sm"></div>
                                        <div class="skeleton__bone skeleton__bone--sm"></div>
                                        <div class="skeleton__bone skeleton__bone--sm"></div>
                                    </div>
                                </div>
                                <div class="skeleton-l-details-panel__right">
                                    <div class="skeleton skeleton--content">
                                        <div class="skeleton__bone"></div>
                                        <div class="skeleton__bone"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                `,
                portId: null,
                portRating: 0,
                portName: '',
                portCode: '',
                portCountry: '',
                ISPSSecurityRating: 0,
                portDetails: cloneDeep(portDetails),
                staticMap: null,
                cityCoordinates: {},
                portCoordinates: {},
                isDownloadReportHasError: false,
                poweredbyRIImage: poweredbyRIImage,
                isLuxuryYachtingModule: false
            }
        },
        created() {
            User.getUser().then(user => {
                this.userEmail = user.email
                this.userName = user.name
                this.userCompany = user.Client
                this.requestInfoUserEmail = user.email
                this.requestInfoUserName = user.name
                this.requestInfoUserCompany = user.Client
            })

            User.getUserPermissions().then(permissions => {
                this.userPermissions = permissions
                if (permissions.includes('luxury_yachting')) {
                    this.isLuxuryYachtingModule = true
                }
            })
        },
        mounted() {
            const staticMapContainer = document.getElementById('staticMap')
            if (staticMapContainer) {
                this.staticMap = new mapboxgl.Map({
                    container: 'staticMap',
                    style: config.LuxuryYachtingModulePortDetailsMapStyleURL,
                    dragRotate: false,
                    touchZoomRotate: false,
                    doubleClickZoom: false,
                    scrollZoom: false,
                    interactive: false,
                    attributionControl: false,
                    boxZoom: false,
                })
                addMapImages(this.staticMap)
            }
            window.addEventListener('resize', this.updateAccordionHeights)
        },
        unmounted() {
            window.addEventListener('resize', this.updateAccordionHeights)
        },
        methods: {
            urlify(content) {
                var regex = /((?:href|src)=")?(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig
                return content.replace(regex, function (match, attr) {
                    if (typeof attr != 'undefined') {
                        return match
                    }
                    return '<a target="_blank" href="' + match + '">' + match + '</a>'
                })
            },
            showRequestInfoFlyout(event) {
                if (event.target.classList.contains('request-info-button')) {
                    this.requestInfoUserEmail = this.userEmail
                    this.requestInfoUserName = this.userName
                    this.requestInfoUserCompany = this.userCompany
                    this.requestInfoUserAdditionalNote = ''
                    this.requestInfoAirportCode = ''
                    this.requestInfoAirport = ''
                    this.requestInfoCity = ''
                    this.requestInfoCountry = ''
                    document.getElementsByClassName('app-template')[0].classList.add('request-info-show')
                }
            },
            showRequestInfoCountry(event, country) {
                this.showRequestInfoFlyout(event)
                this.requestInfoType = 'country'
                this.requestInfoCountry = country
                this.requestInfoTitle = country
                this.requestInfoSubtitle = ''
            },
            showRequestInfoCity(event, city, country) {
                this.showRequestInfoFlyout(event)
                this.requestInfoType = 'city'
                this.requestInfoCity = city
                this.requestInfoCountry = country
                this.requestInfoTitle = city
                this.requestInfoSubtitle = country
            },
            hideRequestInfo() {
                document.getElementsByClassName('app-template')[0].classList.remove('request-info-show')
            },
            submitInfoRequest() {
                this.requestInfoAPIError = ''
                this.requestInfoSubmitted = true

                if (!isEmail(this.requestInfoUserEmail)) return
                if (this.requestInfoUserName.trim() === '') return
                if (this.requestInfoUserCompany.trim() === '') return

                this.isSubmittingRequestInfo = true

                MixPanelService.track('Request Info Submit')

                ClientPortalAPIService.submitRequestInfo({
                    userEmail: this.requestInfoUserEmail,
                    userName: this.requestInfoUserName,
                    userCompany: this.requestInfoUserCompany,
                    userAdditionalNote: this.requestInfoUserAdditionalNote,
                    userRequestInfoForAirportCode: this.requestInfoAirportCode,
                    userRequestInfoForAirport: this.requestInfoAirport,
                    userRequestInfoForCity: this.requestInfoCity,
                    userRequestInfoForCountry: this.requestInfoCountry,
                    userRequestInfoForType: this.requestInfoType,
                    type: 'request info',
                    module: 'luxury-yachting'
                })
                    .then((responseData) => {
                        // TODO: check for successful response, otherwise display an error, need to have API working to check how it will return that status
                        this.requestInfoSuccessfullySubmitted = true
                    })
                    .catch(error => {
                        Sentry.captureException(error)
                        this.requestInfoAPIError = error
                    }).
                    then(() => {
                        this.isSubmittingRequestInfo = false
                        setTimeout(() => {
                            if (this.requestInfoAPIError === '') {
                                this.requestInfoSuccessfullySubmitted = false
                                this.hideRequestInfo()
                            } else {
                                this.requestInfoAPIError = ''
                            }
                        }, 3000);
                    })
            },
            isValidEmail(email) {
                return isEmail(email)
            },
            toggleAccordion(event, element) {
                var accordion = null

                if (element !== undefined) {
                    accordion = element
                } else {
                    accordion = event.target.parentElement
                }

                var contentContainer = accordion.getElementsByClassName('accordion__content-container')[0]
                var contentHeight = accordion.getElementsByClassName('accordion__content')[0].offsetHeight
                if (accordion.classList.contains("show-content")) {
                    accordion.classList.remove('show-content');
                    contentContainer.setAttribute("style", "height: 0")
                } else {
                    accordion.classList.add('show-content');
                    contentContainer.setAttribute("style", "height:" + (parseInt(contentHeight) + 16) + "px")
                }
            },
            seeCovidDetails() {
                this.selectModule('country')
                this.countryCurrentTab = 'Travel'

                this.$nextTick(() => {
                    if (this.$refs.countryCovidRestrictionsAccordian !== undefined &&
                        !this.$refs.countryCovidRestrictionsAccordian.classList.contains('show-content')) {
                        this.toggleAccordion(null, this.$refs.countryCovidRestrictionsAccordian)
                    }
                })
            },
            showLoadingSkeleton() {
                this.$refs.detailsPanelBody.scrollTop = 0;
                document.getElementsByClassName('details-panel')[0].classList.add('show-skeleton')
                document.getElementsByClassName('details-panel')[0].classList.remove('hide-skeleton')
            },
            hideLoadingSkeleton() {
                setTimeout(() => {
                    this.$refs.detailsPanelBody.scrollTop = 0;
                    document.getElementsByClassName('details-panel')[0].classList.remove('show-skeleton')
                    document.getElementsByClassName('details-panel')[0].classList.add('hide-skeleton')

                    if (this.staticMap) this.staticMap.resize()
                }, 600);
            },
            // @adam : please double check this update because localy it was not opening event panel
            findCountryCovidRestrictions(countryISO) {
                const restrictions = this.covidRestrictions?.countryRestrictions
                if (!Array.isArray(restrictions)) return undefined
                return restrictions.find(country => country.countryISO === countryISO)
            },
            getSecurityCMSAPIResponse(responseValue) {
                // API can return "Body" so it comes from the API, or it can be returned as "Content" which indicates
                // that it comes as RTE content from the CMS. This is valid for all API responses below
                if (responseValue !== null && responseValue.Body !== 'null' && !!responseValue.Body) {
                    // Try to parse it as JSON if it's a JSON format, otherwise it will fail, so we know it's just a string
                    try {
                        return JSON.parse(responseValue.Body)
                    } catch { return responseValue.Body }
                } else if (responseValue !== null && responseValue.Content !== 'null' && !!responseValue.Content) {
                    // Medical Only & Comprhensive Crew support should not see any RTE blocks, only results from the APIs
                    if (this.userPermissions.includes('medical') || this.userPermissions.includes('comprehensive_crew_support')) {
                        return ''
                    } else {
                        return responseValue.Content
                    }
                } else {
                    return ''
                }
            },
            showDetailsPanel(cityData, currentActiveModule) {
                this.showLoadingSkeleton()
                if (currentActiveModule === 'city') {
                    this.cityCoordinates = {
                        longitude: cityData.longitude,
                        latitude: cityData.latitude
                    }
                    this.portId = cityData.id ?? null
                } else {
                    this.cityCoordinates = {}
                    if (this.portId) {
                        Ports.hidePortSelected(this.portId)
                        this.portId = null
                    }
                }

                this.showPortDetails = false
                if (currentActiveModule === 'city') {
                    this.selectModule('city')
                }
                this.countryDetailsOnly = false
                this.cityName = cityData.cityName
                this.countryName = cityData.countryName
                this.cityRating = cityData.cityRating
                this.countryRating = cityData.countryRating
                this.countryMedicalRating = cityData.countryMedicalRating
                this.countryISO_3166_1_ALPHA_2 = cityData.ISO_3166_1_ALPHA_2
                this.countryISO_3166_1_ALPHA_3 = cityData.ISO_3166_1_ALPHA_3
                this.ISPSSecurityRating = cityData.ISPSSecurityRating
                this.portRiskAssessmentLevel = cityData.portRiskAssessmentLevel
                this.portCode = cityData.portCode
                this.portName = cityData.portName
                this.portRating = cityData.portRating || 0

                // Reset active tab to overview when opening details panel

                this.cityCurrentTab = 'Overview'
                this.expandAssociatedAlerts = false

                if (currentActiveModule) this.currentActiveModule = currentActiveModule

                // Reset/re-initialize all the options
                this.cityDetails = cloneDeep(cityDetails)
                this.countryDetails = cloneDeep(countryDetails)

                SecurityCMS.getCityDetails(cityData.ISO_3166_1_ALPHA_3, cityData.cityName)
                    .then(cityResults => {
                        const resultNameToVariableMapper = {
                            'city security overview': 'overview.securityOverview',
                            'orientation': 'overview.orientation',
                            'calendar': 'overview.cityCalendar',
                            'crime': 'security.crime',
                            'seeking help': 'security.seekingHelp',
                            'social unrest': 'security.socialUnrest',
                            'terrorism': 'security.terrorism',
                            'trouble spots': 'security.troubleSpots',
                            'embassies and consulates': 'keyinfo.diplomaticRepresentation',
                            'emergency medical care': 'keyinfo.emergencyMedicalCare',
                            'emergency numbers': 'keyinfo.emergencyNumbers',
                            'lodging': 'keyinfo.lodging',
                            'to city centre': 'transport.toCityCentre',
                            'taxis': 'transport.Taxis',
                            'public transport': 'transport.publicTransport',
                            'walking': 'transport.walking',
                            'car hire': 'transport.carHire'
                        }
                        if (cityResults) {
                            cityResults.forEach((result) => {
                                const lowerCasedAPIName = result.Name.toLowerCase()
                                if (resultNameToVariableMapper[lowerCasedAPIName] !== undefined) {
                                    const paths = resultNameToVariableMapper[lowerCasedAPIName].split('.')
                                    if (paths.length === 1) {
                                        this.cityDetails[resultNameToVariableMapper[lowerCasedAPIName]] = this.getSecurityCMSAPIResponse(result.Value)
                                    } else if (paths.length === 2) {
                                        this.cityDetails[paths[0]][paths[1]] = this.getSecurityCMSAPIResponse(result.Value)
                                    }
                                }
                            })
                        }

                        // Now call city guides, so the values from the API can override eventual content blocks from Security CMS
                        return ClientPortalAPIService.getCountryGuideCityInfo(cityData.ISO_3166_1_ALPHA_2, cityData.cityName)
                            .then(countryGuideResults => {
                                if (countryGuideResults !== null) {
                                    const countryGuide = countryGuideResults?.countries?.[0]?.cities?.filter(function (item) {
                                        return item.name == cityData.cityName
                                    })
                                    if (countryGuide) {
                                        countryGuide.forEach((result) => {
                                            if (result.title === 'TO CITY CENTRE' && result.body !== 'null' && !!result.body)
                                                this.cityDetails.transport.toCityCentre = result.body
                                            if (result.title === 'TAXIS' && result.body !== 'null' && !!result.body)
                                                this.cityDetails.transport.Taxis = result.body
                                            if (result.title === 'PUBLIC TRANSPORT' && result.body !== 'null' && !!result.body)
                                                this.cityDetails.transport.publicTransport = result.body
                                            if (result.title === 'WALKING' && result.body !== 'null' && !!result.body)
                                                this.cityDetails.transport.walking = result.body
                                            if (result.title === 'CAR HIRE' && result.body !== 'null' && !!result.body)
                                                this.cityDetails.transport.carHire = result.body
                                        })
                                    }
                                }
                            })
                            .catch(() => { /* Country guide city info unavailable; panel still shows basic city/port data */ })
                    })
                    .catch(() => {
                        /* Security CMS city details unavailable (e.g. 404 for port locations); panel still shows basic city/port data */
                    })
                    .finally(() => {
                        this.hideLoadingSkeleton()
                    })

                this.fetchCountryDetails(cityData.ISO_3166_1_ALPHA_3)
                this.fetchCountryCovidRestrictions(cityData.ISO_3166_1_ALPHA_3)
                this.fetchCountryGuideMedicalInfo(cityData.ISO_3166_1_ALPHA_2)
                this.fetchCountryGuideEntryExitInfo(cityData.ISO_3166_1_ALPHA_2)
                this.fetchInternationalSOSCityAlerts(cityData.latitude, cityData.longitude)
                this.fetchInternationalSOSCountryAlerts(cityData.ISO_3166_1_ALPHA_3)

                if (this.isLuxuryYachtingModule) {
                    MixPanelService.track('City View', {
                        'City Name': cityData.cityName,
                        'Details': `Luxury Yachting | City: ${cityData.cityName} | Country: ${cityData.countryName} (${cityData.ISO_3166_1_ALPHA_3})`
                    })
                } else {
                    MixPanelService.track('Details Panel View - city', {
                        'City': cityData.cityName,
                        'Country': cityData.countryName,
                        'Country Code': cityData.ISO_3166_1_ALPHA_3
                    })
                }

                this.openDetailsPanel()
            },
            showCountryDetailsPanel(countryData, medicalOnly) {
                this.showPortDetails = false
                this.showLoadingSkeleton()

                if (medicalOnly) this.medicalCountryRiskDisplay = true

                this.countryDetailsOnly = true
                this.countryName = countryData.name
                this.countryRating = countryData.countryRating
                this.countryMedicalRating = countryData.countryMedicalRating
                this.countryISO_3166_1_ALPHA_2 = countryData.ISO_3166_1_ALPHA_2
                this.countryISO_3166_1_ALPHA_3 = countryData.ISO_3166_1_ALPHA_3

                this.selectModule('country')
                this.countryCurrentTab = 'Overview'
                this.countryDetails = cloneDeep(countryDetails)
                this.currentCountryCovidRestrictions = cloneDeep(countryCovidRestrictions)

                this.fetchCountryCovidRestrictions(countryData.ISO_3166_1_ALPHA_3)
                this.fetchCountryDetails(countryData.ISO_3166_1_ALPHA_3)
                this.fetchCountryGuideMedicalInfo(countryData.ISO_3166_1_ALPHA_2)
                this.fetchCountryGuideEntryExitInfo(countryData.ISO_3166_1_ALPHA_2)
                this.fetchInternationalSOSCountryAlerts(countryData.ISO_3166_1_ALPHA_3)

                window.setTimeout(() => this.hideLoadingSkeleton(), 2000)

                if (this.isLuxuryYachtingModule) {
                    MixPanelService.track('Country View', {
                        'Country Name': countryData.name,
                        'Details': `Luxury Yachting | Country: ${countryData.name} (${countryData.ISO_3166_1_ALPHA_3})`
                    })
                } else {
                    MixPanelService.track('Details Panel View - country', {
                        'Country': countryData.name,
                        'Country Code': countryData.ISO_3166_1_ALPHA_3
                    })
                }

                this.openDetailsPanel()
            },
            fetchCountryCovidRestrictions(ISO_3166_1_ALPHA_3) {
                this.currentCountryCovidRestrictions = cloneDeep(countryCovidRestrictions)
                const covidDetails = this.findCountryCovidRestrictions(ISO_3166_1_ALPHA_3)
                if (covidDetails !== undefined) {
                    this.currentCountryCovidRestrictions = covidDetails

                    if (covidDetails.impactRatings !== undefined) {
                        // For now we decided that the travel rating will be used for Covid rating not the average value
                        // this.currentCountryCovidRestrictions.generalRating = Math.ceil((covidDetails.impactRatings.domesticOperations + covidDetails.impactRatings.travel) / 2)
                        this.currentCountryCovidRestrictions.generalRating = covidDetails.impactRatings.travel
                        this.currentCountryCovidRestrictions.tooltipContent = this.covidRestrictions.covidImpactDefinitions.domesticOperations[covidDetails.impactRatings.domesticOperations - 1].definition + this.covidRestrictions.covidImpactDefinitions.travel[covidDetails.impactRatings.travel - 1].definition
                        this.currentCountryCovidRestrictions.domesticRatingDisplay = covidDetails.impactRatings.domesticOperations + ' - ' + this.covidRestrictions.covidImpactDefinitions.domesticOperations[covidDetails.impactRatings.domesticOperations - 1].rating
                        this.currentCountryCovidRestrictions.travelRatingDisplay = covidDetails.impactRatings.travel + ' - ' + this.covidRestrictions.covidImpactDefinitions.travel[covidDetails.impactRatings.travel - 1].rating
                    }
                }
            },
            fetchCountryDetails(ISO_3166_1_ALPHA_3) {
                SecurityCMS.getCountryDetails(ISO_3166_1_ALPHA_3)
                    .then((countryResults) => {
                        const resultNameToVariableMapper = {
                            'country assessment': 'overview.assessment',
                            'conclusion': 'overview.conclusion',
                            'local emergency numbers': 'overview.emergencyNumbers',
                            'country travel risk summary': 'travel.riskSummary',
                            'standing travel advice': 'travel.standingTravelAdvice',
                            'country business women': 'travel.businessWomen',
                            'country rule of law': 'background.countryRuleOfLaw',
                            'country travel and security alerts': 'travel.securityAlerts',
                            'country conflict': 'background.countryConflict',
                            'political situation': 'background.politicalSituation',
                            'country corruption': 'background.countryCorruption',
                            'border concerns': 'background.borderConcerns',
                            'country social unrest': 'background.socialUnrest',
                            'country natural disasters': 'background.naturalDisasters',
                            'country recent history': 'background.recentHistory'
                        }
                        if (countryResults) {
                            countryResults.forEach((result) => {
                                const lowerCasedAPIName = result.Name.toLowerCase()
                                if (resultNameToVariableMapper[lowerCasedAPIName] !== undefined) {
                                    if (this.userPermissions.includes('medical') && resultNameToVariableMapper[lowerCasedAPIName] === 'travel.standingTravelAdvice') {
                                        console.log('Hiding standing travel advice for medical users')
                                    } else {
                                        const paths = resultNameToVariableMapper[lowerCasedAPIName].split('.')
                                        if (paths.length === 1) {
                                            this.countryDetails[resultNameToVariableMapper[lowerCasedAPIName]] = this.getSecurityCMSAPIResponse(result.Value)
                                        } else if (paths.length === 2) {
                                            this.countryDetails[paths[0]][paths[1]] = this.getSecurityCMSAPIResponse(result.Value)
                                        }
                                    }
                                }
                            })
                        }
                    })
                    .catch(() => {})
            },
            fetchCountryGuideMedicalInfo(ISO_3166_1_ALPHA_2) {
                ClientPortalAPIService.GetCountryGuideMedicalSummaryMedicalInfo(ISO_3166_1_ALPHA_2)
                    .then((medicalSummaryMedicalInfo) => {
                        if (medicalSummaryMedicalInfo) {
                            this.countryDetails.medical.waterrisk = medicalSummaryMedicalInfo.waterrisk
                            this.countryDetails.medical.foodrisk = medicalSummaryMedicalInfo.foodrisk
                            this.countryDetails.medical.vaccination = medicalSummaryMedicalInfo.vaccination
                            this.countryDetails.medical.routinevaccination = medicalSummaryMedicalInfo.routinevaccination
                            this.countryDetails.medical.medicalalertteaser = medicalSummaryMedicalInfo.medicalalertteaser
                        }
                    })
                    .catch(() => {})
                ClientPortalAPIService.GetCountryGuideMedicalCareMedicalInfo(ISO_3166_1_ALPHA_2)
                    .then((medicalCareMedicalInfo) => {
                        if (medicalCareMedicalInfo) {
                            this.countryDetails.medical.emgresponse = medicalCareMedicalInfo.emgresponse
                            this.countryDetails.medical.outpatientcare = medicalCareMedicalInfo.outpatientcare
                            this.countryDetails.medical.healthcarepayment = medicalCareMedicalInfo.healthcarepayment
                            this.countryDetails.medical.dentalcare = medicalCareMedicalInfo.dentalcare
                            this.countryDetails.medical.availmeds = medicalCareMedicalInfo.availmeds
                            this.countryDetails.medical.bloodsupplies = medicalCareMedicalInfo.bloodsupplies
                        }
                    })
                    .catch(() => {})

                ClientPortalAPIService.GetCountryGuideDiseasesMedicalInfo(ISO_3166_1_ALPHA_2)
                    .then((diseasesMedicalInfo) => {
                        if (diseasesMedicalInfo) {
                            this.countryDetails.medical.diseases = diseasesMedicalInfo.disease
                        }
                    })
                    .catch(() => {})

                ClientPortalAPIService.GetCountryGuideGeneralDiseaseAndPreventionContentMedicalInfo(ISO_3166_1_ALPHA_2)
                    .then((generalDiseaseAndPreventionContentMedicalInfo) => {
                        if (generalDiseaseAndPreventionContentMedicalInfo) {
                            this.countryDetails.medical.GeneralDiseaseAndPreventionContent = generalDiseaseAndPreventionContentMedicalInfo.articlecontent
                        }
                    })
                    .catch(() => {})

                ClientPortalAPIService.GetCountryGuideMedicalReferralsMedicalInfo(ISO_3166_1_ALPHA_2)
                    .then((medicalReferralsMedicalInfo) => {
                    if (medicalReferralsMedicalInfo && medicalReferralsMedicalInfo.hospitalcitynames && medicalReferralsMedicalInfo.hospitals) {
                        const cityHospital = [];
                        medicalReferralsMedicalInfo.hospitalcitynames.forEach(cityObj => {
                            const obj = {
                                cityName: cityObj.city,
                                list: medicalReferralsMedicalInfo.hospitals.filter(obj => obj.city === cityObj.city)
                            }
                            cityHospital.push(obj)
                        })

                        // iterate over each city in the original object
                        for (const city of cityHospital) {
                            const hospitalParsed = []
                            const existingHospitalPhoneNumbers = {}

                            city.list = city.list.filter(hospital => {
                                if (existingHospitalPhoneNumbers[hospital.providerid] === undefined) {
                                    existingHospitalPhoneNumbers[hospital.providerid] = []
                                }
                                existingHospitalPhoneNumbers[hospital.providerid].push(hospital.phonenumber)
                                if (hospitalParsed.indexOf(hospital.providerid) === -1) {
                                    hospitalParsed.push(hospital.providerid)
                                    return true
                                } else {
                                    return false
                                }
                            })

                            city.list = city.list.map(hospital => {
                                return {
                                    ...hospital,
                                    phonenumber: existingHospitalPhoneNumbers[hospital.providerid].join(', ')
                                }
                            })
                        }
                        this.countryDetails.medical.medicalReferrals = cityHospital
                    }
                })
                    .catch(() => {})
            },
            fetchCountryGuideEntryExitInfo(ISO_3166_1_ALPHA_2) {
                ClientPortalAPIService.getCountryGuideEntryExitInfo(ISO_3166_1_ALPHA_2)
                    .then(entryExitInfo => {
                        if (entryExitInfo !== null) {
                            this.countryDetails.travel.entryExitRequirements = entryExitInfo.passportvisadetails
                        }
                    })
                    .catch(() => {})
            },
            fetchInternationalSOSCityAlerts(latitude, longitude) {
                InternationalSOSAlerts.getModuleAlerts()
                    .then(values => {
                    const cityAlerts = filterInternationalSOSAlerts(values, [latitude, longitude])
                    let simplifiedCityAlers = []
                    cityAlerts.forEach(alert => {
                        simplifiedCityAlers.push({
                            id: alert.Id,
                            displayDateUTC: alert.CreatedDate !== '' ? this.getDisplayDate(alert.CreatedDate) : '',
                            displayDateUTCWithTimeZone: alert.CreatedDate !== '' ? this.getDisplayDateTime(alert.CreatedDate) : '',
                            heading: alert.Title,
                            distanceFromAirport: alert.distanceFromAirport,
                            alertType: alert.Service,
                            createdDate: alert.CreatedDate,
                            activeFrom: alert.ActiveFrom,
                            activeTo: alert.ActiveTo
                        })
                    })

                    // Sort by distance from airport
                    this.cityDetails.alerts = simplifiedCityAlers.sort((a, b) => a.distanceFromAirport - b.distanceFromAirport)
                })
                    .catch(() => {})
            },
            fetchInternationalSOSCountryAlerts(ISO_3166_1_ALPHA_3) {
                InternationalSOSAlerts.getModuleAlerts()
                    .then(values => {
                        values.forEach(alert => {
                            const countryIsoList = alert.Locations.features[0].properties.CountryIsoList
                            if (countryIsoList.toLowerCase() === ISO_3166_1_ALPHA_3.toLowerCase()) {
                                this.countryDetails.alerts.push({
                                    id: alert.Id,
                                    displayDateUTC: alert.CreatedDate !== '' ? this.getDisplayDate(alert.CreatedDate) : '',
                                    displayDateUTCWithTimeZone: alert.CreatedDate !== '' ? this.getDisplayDateTime(alert.CreatedDate) : '',
                                    heading: alert.Title,
                                    alertType: alert.Service,
                                    createdDate: alert.CreatedDate,
                                    activeFrom: alert.ActiveFrom,
                                    activeTo: alert.ActiveTo
                                })
                            }
                        })
                    })
                    .catch(() => {})
            }, 
            fetchPortDetails(portId) {
                RiskIntelligenceAPIService.getPortInformationById(portId)
                    .then(portDetails => {
                        this.portDetails.vulnerabilities.summary = portDetails?.vulnerabilityAssessment?.summary
                        this.portDetails.vulnerabilities.mitigationMethods = portDetails?.vulnerabilityAssessment?.mitigationMethods
                        this.portDetails.security.summary = portDetails?.securityRiskAssessment?.summary
                        this.portDetails.security.recommendations = portDetails?.securityRiskAssessment?.recommendations
                        this.portDetails.threatAssessment.summary = portDetails.threatAssessment?.summary
                        this.portDetails.threatAssessment.threats = portDetails.threatAssessment?.threats || []

                        if (this.portDetails.security.summary)
                            this.portCurrentTab = 'Security'
                        else if (this.portDetails.vulnerabilities.summary)
                            this.portCurrentTab = 'Vulnerability'
                        else if (this.portDetails.threatAssessment?.threats?.length > 0)
                            this.portCurrentTab = 'Threat'
                        else if (this.portDetails.alerts.length > 0)
                            this.portCurrentTab = 'Alerts'
                        else
                            this.portCurrentTab = ''
                    })
                    .catch(() => { /* Risk Intelligence API unavailable; port details not shown */ })
            },
            openAlert(alert, isAviationAlert) {
                if (!!isAviationAlert) {
                    AvsecAlerts.showAlert(alert.isoCode)
                } else {
                    InternationalSOSAlerts.showAlert(alert.id)
                }
            },
            openDetailsPanel() {
                document.getElementsByClassName('app-template')[0].classList.add('details-panel-show')
                this.isDetailsPanelOpen = true
            },
            hideDetailsPanel() {
                document.getElementsByClassName('app-template')[0].classList.remove('details-panel-show')
                this.isDetailsPanelOpen = false
                CountryRisk.unhighlightCountry()
                if (this.portId) {
                    Ports.hidePortSelected(this.portId)
                }
                this.portRating = 0
            },
            isObjectEmpty(obj) {
                if (obj == null) return true
                return Object.keys(obj).length === 0
            },
            isParentObjectEmpty(obj, fieldsToIgnore) {
                let areAllPropertiesEmpty = true

                for (const key in obj) {
                    if (Object.hasOwnProperty.call(obj, key)) {
                        const objectProperty = obj[key]

                        if ((typeof objectProperty === 'string' && objectProperty !== '') || !this.isObjectEmpty(objectProperty)) {
                            if (fieldsToIgnore === undefined || (fieldsToIgnore !== undefined && fieldsToIgnore.indexOf(key) === -1)) {
                                areAllPropertiesEmpty = false
                                break
                            }
                        }
                    }
                }

                return areAllPropertiesEmpty
            },
            getLengthOfPinnedItems() {
                return AirportPins.$data.pinnedAirports.length
            },
            getCurrentPinnedIndex() {
                return AirportPins.findAirportIndex(this.airportBasicData.airportId)
            },
            previousPinnedItem() {
                AirportPins.openPreviousPinnedItem()
            },
            nextPinnedItem() {
                AirportPins.openNextPinnedItem()
            },
            getDisplayDateTime(timestamp) {
                return moment(timestamp).format('DD MMM YYYY HH:mm') + ' ' + guessedTimeZone
            },
            getDisplayDate(UTCDate) {
                return moment(UTCDate).format('DD MMM YYYY') + ' ' + guessedTimeZone
            },
            getMedicalRishRatingDescription(medicalRisk) {
                return riskDefinitions.medical[medicalRisk]
            },
            selectModule(moduleName) {
                this.currentActiveModule = moduleName

                if (moduleName === 'country') {
                    CountryRisk.highlightCountry(this.countryISO_3166_1_ALPHA_2)
                } else {
                    CountryRisk.unhighlightCountry()
                }

                if (this.portId) {
                    Ports.hidePortSelected(this.portId)
                }

                if (moduleName === 'city') {
                    Cities.flyToCity(this.cityCoordinates)
                }


                this.$nextTick(() => {
                    const activeTab = document.querySelector('.main-tabs .is-active-tab')
                    const detailsPanelActiveTabIndicator = document.getElementById('details-panel-active-tab-indicator')
                    if (activeTab && detailsPanelActiveTabIndicator) {
                        const offsetWidth = parseInt(activeTab.offsetWidth, 10)
                        const offsetLeft = parseInt(activeTab.offsetLeft, 10)
                        detailsPanelActiveTabIndicator.setAttribute('style', `width: ${offsetWidth}px; transform: translateX(${offsetLeft}px);`)
                    }
                })
            },
            exportReport() {
                if (!this.isDownloadingReport) {
                    this.isDownloadingReport = true

                    let exportedData = {}
                    exportedData.countryDetails = this.countryDetails
                    exportedData.countryDetails.travel.travelRestrictions = this.currentCountryCovidRestrictions.restrictionList
                    exportedData.cityName = this.cityName
                    exportedData.countryName = this.countryName
                    exportedData.covidImpactRatings = this.currentCountryCovidRestrictions.impactRatings

                    if (!!exportedData.countryDetails.travel && exportedData.countryDetails.travel.securityAlerts !== undefined && typeof exportedData.countryDetails.travel.securityAlerts === 'string') {
                        exportedData.countryDetails.travel.securityAlerts = null
                    }

                    let reportType = this.currentActiveModule
                    if (this.currentActiveModule === 'city') {
                        exportedData.cityDetails = this.cityDetails
                        exportedData.cityRating = this.cityRating
                        exportedData.cityDetails.keyStats = {}
                        exportedData.alerts = this.cityDetails.alerts
                        exportedData.cityDetails.keyStats.riskZoneRating = this.cityRating
                    } else if (this.currentActiveModule === 'country') {
                        exportedData.countryRating = this.countryRating
                        exportedData.medicalRating = this.countryMedicalRating
                        exportedData.countryDetails.keyStats = {}
                        exportedData.countryDetails.keyStats.travelRiskRating = this.countryRating
                        exportedData.countryDetails.keyStats.medicalRiskRating = this.countryMedicalRating
                        exportedData.countryDetails.keyStats.covidImpactData = exportedData.covidImpactRatings
                        exportedData.alerts = this.countryDetails.alerts

                    } else if (this.currentActiveModule === 'port') {
                        exportedData.ISPSSecurityRating = this.ISPSSecurityRating
                        exportedData.portRiskAssessmentLevel = this.portRiskAssessmentLevel
                        exportedData.portCode = this.portCode
                        exportedData.portName = this.portName
                        exportedData.portRating = this.portRating
                        exportedData.portDetails = this.portDetails
                    }

                    exportedData.alerts = exportedData?.alerts?.filter(res => {
                        const alertDate = moment(res.createdDate)
                        const todayMinus72Hours = moment().subtract(72, 'hours')
                        
                        // Include alerts issued in the last 72 hours
                        const isWithin72Hours = alertDate.isAfter(todayMinus72Hours)
                        
                        // Check if this is an InternationalSOS alert (has activeFrom or activeTo property)
                        const hasActiveFrom = res.activeFrom !== undefined && res.activeFrom !== null && res.activeFrom !== ''
                        const hasActiveTo = res.activeTo !== undefined && res.activeTo !== null && res.activeTo !== ''
                        const isInternationalSOSAlert = hasActiveFrom || hasActiveTo
                        
                        // For InternationalSOS alerts, include if within 72 hours OR if currently active
                        // An alert is active if ActiveTo is null/undefined/empty OR if current time is before or equal to ActiveTo
                        // If ActiveFrom exists but ActiveTo is null, the alert should be included
                        if (isInternationalSOSAlert) {
                            // If activeTo is null/undefined/empty but activeFrom exists, consider it active
                            if (!hasActiveTo && hasActiveFrom) {
                                return true
                            }
                            // If activeTo exists, check if current time is before or equal to activeTo
                            if (hasActiveTo) {
                                const activeToDate = moment(res.activeTo)
                                const isActive = moment().isSameOrBefore(activeToDate)
                                return isWithin72Hours || isActive
                            }
                        }
                        
                        // Default: only include if within 72 hours
                        return isWithin72Hours
                    }) || []

                    if (this.userPermissions.includes('medical')) {
                        exportedData.countryRating = null
                    }

                    // Our test envirnoment comes with wrong old data format, this is not ideal, but it's a quick fix for now
                    if (typeof exportedData.countryDetails.travel.riskSummary === 'object') {
                        exportedData.countryDetails.travel.riskSummary = ''
                    }

                    let finalData = cloneDeep(exportedData)

                    delete finalData?.countryDetails?.travel?.travelRestrictions
                    delete finalData?.countryDetails?.alerts

                    ClientPortalAPIService.downloadBriefBuilderReport(reportType.toString(), JSON.stringify(finalData)).then(res => {
                        try {
                            if (res) {
                                const pdfBlob = new Blob([res], { type: "application/pdf" });
                                // Create a URL for the Blob
                                const blobUrl = URL.createObjectURL(pdfBlob);
                                let filename = ''
                                if (this.currentActiveModule === 'city') {
                                    filename = this.cityName?.replace(/,/g, '') || ''
                                } else if (this.currentActiveModule === 'country') {
                                    filename = this.countryName?.replace(/,/g, '') || ''
                                } else if (this.currentActiveModule === 'port') {
                                    filename = this.portName?.replace(/,/g, '') || ''
                                }
                                // Create a link and simulate clicking to trigger the download
                                const link = document.createElement("a");
                                link.href = blobUrl;
                                link.download = `Report-${filename}.pdf`;
                                link.target = "_blank";
                                link.click();

                                // Clean up the Blob URL
                                URL.revokeObjectURL(blobUrl);
                            }
                            this.isDownloadingReport = false
                            this.previousReport = null
                            this.isPreviousReportDownloading = false

                        } catch (error) {
                            console.log('brief-builder download pdf error', error)
                            this.isDownloadingReport = false
                            this.isDownloadReportHasError = true
                            this.previousReport = null
                            this.isPreviousReportDownloading = false
                        }
                    }).catch(error => {
                        console.log('brief-builder download report server error', error)
                        this.isDownloadingReport = false
                        this.isDownloadReportHasError = true
                    }).finally(() => {
                        this.isDownloadingReport = false
                    })
                    
                    if (this.isLuxuryYachtingModule) {
                        MixPanelService.track('Download Report', {
                            'Report Name': reportType,
                            'Source': 'Luxury Yachting',
                            'Details': `${this.cityName}, ${this.countryName}`
                        })
                    } else {
                        MixPanelService.track('Download Report', {
                            'Report Name': reportType,
                            'Source': 'Security Portal',
                            'Type': reportType
                        })
                    }
                }
            },
            createMapBoxStaticMap(cityData) {
                const data = {
                    type: 'FeatureCollection',
                    features: [
                        {
                            type: 'Feature',
                            geometry: {
                                type: 'Point',
                                coordinates: [cityData.longitude, cityData.latitude]
                            }
                        }
                    ]
                }
                let portsSource = this.staticMap.getSource('ports')
                if (portsSource === undefined) {
                    this.staticMap.addSource('ports', {
                        'type': 'geojson',
                        'data': data
                    })

                    this.staticMap.addLayer({
                        id: 'ports',
                        type: 'symbol',
                        source: 'ports',
                        layout: {
                            'visibility': 'visible',
                            'icon-image': 'port-risk-0',
                            'icon-size': .7,
                        }
                    })
                    this.staticMap.jumpTo({
                        center: [cityData.longitude, cityData.latitude],
                        zoom: 13
                    })
                } else {
                    portsSource.setData(data)
                    this.staticMap.resize()
                    this.staticMap.jumpTo({
                        center: [cityData.longitude, cityData.latitude],
                        zoom: 13
                    })
                }
            },
            getHtml(description) {
                if (description) {
                    description = description.replace(/\r\n/g, '<br/>')
                    return description
                } else {
                    return ''
                }
            },
            updateAccordionHeights() {
                setTimeout(() => {
                    const accordionContainer = document.getElementsByClassName('show-content')
                    if (accordionContainer.length > 0) {
                        for (let index = 0; index < accordionContainer.length; index++) {
                            const contentContainer = accordionContainer[index].getElementsByClassName('accordion__content-container')[0]
                            const contentHeight = accordionContainer[index].getElementsByClassName('accordion__content')[0].offsetHeight
                            contentContainer.setAttribute("style", "height:" + (parseInt(contentHeight) + 16) + "px")
                        }
                    }
                }, 250)
            },
            isCountryOverviewDataAvailable() {
                return (
                    // check if overview data is available and not medical and comp user
                    this.isParentObjectEmpty(this.countryDetails.overview) &&
                    !(
                        this.userPermissions.includes('medical') ||
                        this.userPermissions.includes('comprehensive_crew_support')
                    )
                ) ||
                    (
                        // check if not ly user. As we don't have riskSummary data for ly user in overview tab.
                        !this.userPermissions.includes('luxury_yachting') &&
                        // for medical and comp user, we need to check if the riskSummary data is available. 
                        !(
                            this.countryDetails.travel.riskSummary !== '' &&
                            (
                                this.userPermissions.includes('medical') ||
                                this.userPermissions.includes('comprehensive_crew_support')
                            )
                        ))
            }
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-city-details-panel')

    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).use({
            install: (app) => {
                app.directive('tooltip', {
                    beforeMount(el) {
                        tippy(el, {
                            content: '',
                            placement: 'bottom-start',
                            animation: 'shift-away',
                            allowHTML: true,
                            trigger: 'mouseenter click focus',
                            arrow: false,
                            interactive: true,
                            followCursor: true,
                            plugins: [followCursor]
                        })
                    },
                    updated(el, binding, vnode) {
                        // https://atomiks.github.io/tippyjs/v6/tippy-instance/#-property
                        el._tippy.setContent(vnode.props.content)
                    }
                })
            }
        })
            .use(Donut)
            .mount(DOMElement)
    }
})();